import { Outlet } from "react-router-dom";

export default function AuthLayout() {
  return (
    <div className="relative flex min-h-[100svh] justify-center overflow-x-hidden bg-main-dark">
      <div className="pointer-events-none absolute left-0 top-0 shrink-0 -ml-44 -mt-44 opacity-40 sm:-ml-28 sm:-mt-28 sm:opacity-100">
        <img
          src="/bg_brand.png"
          className="h-[520px] sm:h-[700px]"
          alt="bg-left"
        />
      </div>
      <div className="relative z-10 flex min-h-[100svh] w-full items-start justify-center overflow-y-auto px-4 py-8 sm:items-center sm:px-6 sm:py-12">
        <Outlet />
      </div>
      <div className="pointer-events-none absolute bottom-0 right-0 shrink-0 -mb-44 -mr-44 opacity-40 sm:-mb-28 sm:-mr-28 sm:opacity-100">
        <img
          src="/bg_brand.png"
          className="h-[520px] sm:h-[700px]"
          alt="bg-right"
        />
      </div>
    </div>
  );
}
